<template>
    <div class="section">
        <div class="part">
            <div class="tle-row">
                <div v-if="this.active_study.etudeType.nom!=='Flash'" class="tle-col four-fifth mapComponent" :class="{no_edit: editor.mode != 'editing'}" :style="{'z-index': editor.mode == 'editing' ? 10001 : 0}">
                    <map-component height="225" allow_ventes :allow_programs="false" allow_annotations :view="true"/>
                </div>
                <div v-else  class="tle-col mapComponent" :class="{no_edit: editor.mode != 'editing'}" :style="{'z-index': editor.mode == 'editing' ? 10001 : 0}">
                    <map-component height="225" allow_ventes :allow_programs="false" allow_annotations :view="true"/>
                </div>
                <div v-if="this.active_study.etudeType.nom!=='Flash'" class="tle-col one-fifth">
                    <div class="part part-images">
                        <div class="q-mb-sm">
                            <el-image
                                :parent_data="active_study.etudeData.gie.sectionAnalyseDeSite.images[0]"
                                property="src"
                                :editable="true"
                                max_height="90px"
                                edition_position="right"
                            />
                            <el-textarea
                                :parent_data="active_study.etudeData.gie.sectionAnalyseDeSite"
                                property="titre_photo1"
                                :editable="true"
                                class="text-center text-italic image-description"
                            />
                        </div>
                        <div>
                            <el-image
                                :parent_data="active_study.etudeData.gie.sectionAnalyseDeSite.images[1]"
                                property="src"
                                :editable="true"
                                max_height="90px"
                                edition_position="right"
                            />
                            <el-textarea
                                :parent_data="active_study.etudeData.gie.sectionAnalyseDeSite"
                                property="titre_photo2"
                                :editable="true"
                                class="text-center text-italic image-description"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="tle-row">
            <div class="tle-col two-fifth">
                <div>
                    <p class="label-small">Accessibilité</p>
                    <el-progress-slider
                        :parent_data="active_study.etudeData.gie.sectionAnalyseDeSite.notes"
                        property="accessibilite"
                        :max="10"
                        :editable="true"
                    />
                </div>
                <div>
                    <p class="label-small">Commerces, équipements et services de proximité</p>
                    <el-progress-slider
                        :parent_data="active_study.etudeData.gie.sectionAnalyseDeSite.notes"
                        property="commerces_equipements_services"
                        :max="10"
                        :editable="true"
                    />
                </div>
                <div>
                    <p class="label-small">Notoriété résidentielle</p>
                    <el-progress-slider
                        :parent_data="active_study.etudeData.gie.sectionAnalyseDeSite.notes"
                        property="notoriete_residentielle"
                        :max="10"
                        :editable="true"
                    />
                </div>
                <div>
                    <p class="label-small">Environnement bâti et vue/dégagement</p>
                    <el-progress-slider
                        :parent_data="active_study.etudeData.gie.sectionAnalyseDeSite.notes"
                        property="environnement_bati_vue_degagement"
                        :max="10"
                        :editable="true"
                    />
                </div>
                <div>
                    <p class="label-small">Espaces verts</p>
                    <el-progress-slider
                        :parent_data="active_study.etudeData.gie.sectionAnalyseDeSite.notes"
                        property="espaces_verts"
                        :max="10"
                        :editable="true"
                    />
                </div>
                <div>
                    <p class="label-small">Nuisances (bruit, pollution, etc...)</p>
                    <el-progress-slider
                        :parent_data="active_study.etudeData.gie.sectionAnalyseDeSite.notes"
                        property="nuisances"
                        :max="10"
                        :editable="true"
                    />
                </div>
                <p class="legend" v-if="this.active_study.etudeType.nom==='Flash'">Analyse sans visite de site</p>
            </div>
            <div class="tle-col three-fifth">
                <div class="comment">
                    <el-textarea
                        class="detail-site"
                        :parent_data="active_study.etudeData.gie.sectionAnalyseDeSite"
                        property="commentaire"
                        :editable="true"
                        placeholder="Commentaire"
                        :height="this.active_study.etudeType.nom==='Flash' ?'243px' : '153px'"
                        overflow_edit='hidden scroll'
                    />
                </div>
                <div v-if="active_study.etudeType.nom!=='Flash'">
                    <p class="label-small">Niveau d'attractivité actuel du site</p>
                    <el-progress-slider
                        :parent_data="active_study.etudeData.gie.sectionAnalyseDeSite.notes"
                        property="attractivite_actuelle"
                        :max="10"
                        :editable="true"
                        selector_bg="orange_selector"
                    />
                </div>
                <div v-if="active_study.etudeType.nom!=='Flash'">
                    <p class="label-small">Niveau d'attractivité du site à court terme</p>
                    <el-progress-slider
                        :parent_data="active_study.etudeData.gie.sectionAnalyseDeSite.notes"
                        property="attractivite_court_terme"
                        :max="10"
                        :editable="true"
                        selector_bg="orange_selector"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";
import MapComponent from "../../elements/MapComponent";

export default {
	name: "section-gie-analyse-de-site",
	mixins: [ PageMixin ],
	components: { MapComponent },
	data: function () {
		return {
			
		};
	},
	props: {
		main_color: { default: "" },
	},
	computed: {
		...mapGetters(["active_study", "editor", "app_parameters"])
	},
};
</script>

<style lang="stylus" scoped>
@import '../../../../../assets/css/app'
@import '../../../../../assets/css/page'
</style>

<style lang="scss">
.mapComponent.no_edit {
  &::before {
    content: "";
    position: absolute;
    z-index: 1000;
    background: #FFFFFF00;
    width: 100%;
    height: 100%;
  }
}
</style>
